import { z } from 'zod';

// See https://datatracker.ietf.org/doc/html/rfc7807

export const ResponseProblemJsonBody = z.object({
    title: z.string(),
    status: z.int(),
    errors: z.record(z.string(), z.string().array()).nullish(),
    type: z.string().nullish(),
    detail: z.string().nullish(),
    traceId: z.string().nullish(),
});
export type ResponseProblemJsonBody = z.infer<typeof ResponseProblemJsonBody>;
